import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {User} from '../models/user.model';
import {DirectBookingHttpService} from './direct-booking-http.service';

/** Session storage key caching the authenticated user across reloads. */
export const USER_SESSION_STORAGE_KEY = 'user';

@Injectable({
  providedIn: 'root',
})
export class UserWebService {
  private readonly httpClient = inject(HttpClient);
  private readonly backend = inject(DirectBookingHttpService);

  /**
   * Retrieves the currently authenticated user. The backend resolves the user
   * from the forwarded bearer token.
   *
   * @returns Observable containing the authenticated user.
   */
  public getUser(): Observable<User> {
    return this.httpClient.get<User>(
      `${this.backend.apiBaseUrl}/user`,
      {headers: this.backend.authorizationHeaders()},
    );
  }
}
